import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import AssetCopierPanelFooter from './AssetCopierPanelFooter';
import { AssetCopierProvider } from '../providers/AssetCopierProvider';
import AssetCopierPanelBody from './AssetCopierPanelBody';
import ErrorBoundary from '../common/ErrorBoundary';
import { trackInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssetCopierPanel(props) {
  const {
    onClose,
    assets,
    portableType,
    onCopyComplete
  } = props;
  useEffect(() => {
    trackInteraction({
      action: 'PANEL_OPENED',
      assetType: portableType
    });
  }, [portableType]);
  const handleClose = () => {
    trackInteraction({
      action: 'PANEL_CLOSED',
      assetType: portableType
    });
    onClose();
  };
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(AssetCopierProvider, {
      assets: assets,
      portableType: portableType,
      onCopyComplete: onCopyComplete,
      children: /*#__PURE__*/_jsxs(ModalPanel, {
        "data-test-id": "asset-copier-panel",
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ui-multi-account-asset-copier.panel.title"
            })
          }), /*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: handleClose
          })]
        }), /*#__PURE__*/_jsx(DialogBody, {
          children: /*#__PURE__*/_jsx(AssetCopierPanelBody, {})
        }), /*#__PURE__*/_jsx(AssetCopierPanelFooter, {
          onClickDone: handleClose
        })]
      })
    })
  });
}
export default AssetCopierPanel;